export const DRAG_AND_DROP_CONSTANTS = {
	DIRECTION: 'horizontal',
	COLUMN: 'column',
	PAGE: 'page',
	TRASHCAN: 'trashcan',
	UNORDERED_TYPE: 'not_detected',
};
